/**
 * The order page's planned, not yet built, sections as placeholders
 * (docs/features/order-to-invoice/16_frontend_followup_spec.md §3.2). The
 * page is one card with no tabs (Ben, 3 Oct), so a planned section is a
 * rail step whose panel is not built, or a group of rows in the action box,
 * a step's panel or Details.
 *
 * Every `NotBuiltYet planned="…"` below is a string literal on purpose:
 * `scripts/check-planned-sections.mjs` reads this file to prove each manifest
 * entry is rendered exactly once. Building a section means deleting its entry
 * from the manifest and its line from here.
 */
import { isFeatureEnabled } from "@shared-core/config/features";
import { NotBuiltYet } from "../../patterns/NotBuiltYet";

/**
 * The planned row groups in one place on the order page, where the journeys
 * branch's mock-ups draw them: the action box's rows that arrive with later
 * steps (doc 27 §4, "sketch"); Tharstern jobs and pick lists in Details; the
 * carrier handover in the Delivery step.
 */
export function PlannedOrderRowGroups({
  where,
}: {
  where: "action_box" | "details" | "delivery_step";
}) {
  // No wrapper of its own when off: an empty element would still take space.
  if (!isFeatureEnabled("previews")) return null;
  switch (where) {
    case "action_box":
      return (
        <div className="space-y-1">
          <NotBuiltYet planned="order.row_group.proforma" />
          <NotBuiltYet planned="order.row_group.supplier_confirmation" />
          <NotBuiltYet planned="order.row_group.in_house" />
          <NotBuiltYet planned="order.row_group.from_stock" />
          <NotBuiltYet planned="order.row_group.carrier" />
        </div>
      );
    case "details":
      return (
        <div className="space-y-1">
          <NotBuiltYet planned="order.row_group.tharstern_jobs" />
          <NotBuiltYet planned="order.row_group.pick_lists" />
        </div>
      );
    case "delivery_step":
      return <NotBuiltYet planned="order.row_group.carrier_handover" />;
  }
}
